// Stable per-browser fingerprint used to lock a POS terminal to one workstation.
// Kept as a UUID in localStorage — first-generated once, reused thereafter.
export function getClientId() {
  let id = localStorage.getItem("pos_client_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) ||
      `c-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("pos_client_id", id);
  }
  return id;
}
